import React from 'react';

import { unCamelCase } from './../../helpers/camelCase';

import { TextField } from '@material-ui/core';

const EditableInput = ({ data, setData, labels }) => {
  return labels.map(label => (
    <TextField
      key={label}
      data-testid="inputEdit"
      InputLabelProps={{ shrink: true }}
      label={unCamelCase(label)}
      value={data[label]}
      onChange={e => {
        setData({ ...data, [label]: e.target.value });
      }}
    />
  ));
};

export default EditableInput;
